export default __webpack_public_path__ + "static/media/reactangular_icon.5508bdec.webp";